import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { SavedForm } from '../classes/savedForm';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Statique } from '../utils/statique';
import { SavedFormIdentifier } from '../utils/enumeration';
import { EbUser } from '../classes/user';
import { Subject } from 'rxjs';


/**
 * SavedFormService here is a singleton shared between components
 */

let instance = null;

@Injectable()
export class SavedFormsService {
	statique = Statique
	private savedFormSource: BehaviorSubject<SavedForm> = new BehaviorSubject(null);
	selectedSavedForm$: Observable<SavedForm> = this.savedFormSource.asObservable();
	///------
	private notifyComponent = new Subject<any>();
	private notifyListingComponent = new Subject<any>();

	SavedFormsObservale = this.notifyComponent.asObservable();
	listingSavedFormsObservale = this.notifyListingComponent.asObservable();

	public notifyComponentSavedForms(data: any) {
		this.notifyComponent.next(data);
	}

	public notifyListingComponentSavedForms(data: any) {
		this.notifyListingComponent.next(data);
	}
	//----------
	constructor(private http: Http) {
		if (!instance)
			instance = this;

		return instance;
	}

	getSavedForms(sf) {
		return this.http.post(Statique.controllerSavedForm + "/getByComponentAndUser", {
			ebCompNum: sf.ebCompNum,
			ebUserNum: sf.ebUserNum
		}).map(res => res.json());
	}

	saveSavedForm(sf) {
		if (!sf.ebUser)
			throw new Error("User is undefined");

		return this.http.post(Statique.controllerSavedForm + "/upsert", sf).map(res => res.json());
	}

	saveHistory(ebUser: EbUser, ebModuleNum: number, path: string, name: string = null) {
		if (!ebUser)
			throw new Error("User is undefined");

		let sf: SavedForm = new SavedForm();
		sf.ebCompNum = SavedFormIdentifier.HISTORY;
		sf.ebModuleNum = ebModuleNum;
		sf.ebUser = ebUser;
		sf.formName = name || Statique.getModuleNameByModuleNum(ebModuleNum);
		sf.formValues = path;

		this.saveSavedForm(sf).subscribe(result => {
			this.notifyComponentSavedForms(result);
		});
	}

	saveFavoris(ebUser: EbUser, ebModuleNum: number, path: string) {
		if (!ebUser)
			throw new Error("User is undefined");

		let sf: SavedForm = new SavedForm();
		sf.ebCompNum = SavedFormIdentifier.FAVORIS;
		sf.ebModuleNum = ebModuleNum;
		sf.ebUser = ebUser;
		sf.formName = Statique.getModuleNameByModuleNum(ebModuleNum);
		sf.formValues = path;

		this.saveSavedForm(sf).subscribe();
	}

	deleteSavedForm(sf) {
		return this.http.post(Statique.controllerSavedForm + "/delete", {
			ebSavedFormNum: sf.ebSavedFormNum
		}).map(res => res.json());
	}

	emitSavedForm(sf: SavedForm) {
		this.savedFormSource.next(sf);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/saved-forms.service.ts